// frontend/src/pages/dashboard/TaskComponents/TaskCardSkeleton.js

import React from "react";
import { Paper, Box, Grid, Skeleton } from "@mui/material";

const TaskCardSkeleton = () => (
  <Paper sx={{ borderRadius: 2, boxShadow: 2, p: 2, mb: 2 }}>
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        mb: 1,
      }}
    >
      <Box sx={{ width: "100%" }}>
        <Skeleton variant="text" width="60%" height={40} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="80%" height={20} />
      </Box>
      <Skeleton variant="rectangular" width={40} height={24} />
    </Box>
    <Grid container spacing={2} sx={{ mb: 2 }}>
      {[1, 2, 3, 4].map((item) => (
        <Grid item size={{ xs: 12, sm: 6, md: 3 }} key={item}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Skeleton variant="circular" width={20} height={20} />
            <Skeleton variant="text" width="80%" height={20} />
          </Box>
        </Grid>
      ))}
    </Grid>
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
        flexWrap: "wrap",
        gap: 1,
      }}
    >
      <Box>
        <Skeleton variant="text" width={100} height={16} sx={{ mb: 0.5 }} />
        <Box sx={{ display: "flex", gap: 0.5 }}>
          {[1, 2, 3].map((item) => (
            <Skeleton key={item} variant="circular" width={24} height={24} />
          ))}
        </Box>
      </Box>
      <Box>
        <Skeleton variant="text" width={60} height={16} sx={{ mb: 0.5 }} />
        <Skeleton variant="rectangular" width={80} height={24} />
      </Box>
    </Box>
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box sx={{ display: "flex", gap: 1 }}>
        <Skeleton variant="circular" width={32} height={32} />
        <Skeleton variant="circular" width={32} height={32} />
      </Box>
      <Box sx={{ display: "flex", gap: 0.5 }}>
        {[1, 2, 3].map((item) => (
          <Skeleton key={item} variant="circular" width={32} height={32} />
        ))}
      </Box>
    </Box>
  </Paper>
);

export default TaskCardSkeleton;